import type { CartItemOutputDto } from "@sticker-giant/sg-frontend-common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { trackItemRemovedFromCart } from "@/lib/analytics/segment";
import { CART_QUERY_KEY } from "@/queries/useCart";
import { useServicesStore } from "@/stores/useServicesStore";

export const removeCartItemMutationKey = ["removeCartItem"] as const;

export function useRemoveCartItem(item: CartItemOutputDto) {
  const cartClient = useServicesStore(state => state.cartClient);
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: removeCartItemMutationKey,
    mutationFn: async () => {
      if (!cartClient) throw new Error("Cart client is not available.");
      await cartClient.removeCartItem(item.id);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: CART_QUERY_KEY });
      trackItemRemovedFromCart(item);
    },
  });
}
